<template>
  <b-overlay :show="loading">
    <b-container fluid>

      <b-row align-h="center">
        <b-col cols="12" lg="6">

          <!-- Podcast Evaluation -->
          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">Evaluation</span>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="mt-2 mb-3">{{blurb}}</b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <strong>Title</strong>
              </b-col>
              <b-col cols="9">{{podcast.title}}</b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <strong>Released</strong>
              </b-col>
              <b-col>{{podcast.releaseDate | prettyDate}}</b-col>
            </b-row>
          </div>

          <div class="div-section-body mt-3">
            <div class="div-padding">
              <b-form @submit.prevent="submitEval">
                <div class="div-eval-section">Please rate the content</div>

                <!-- https://bootstrap-vue.js.org/docs/components/form-radio -->
                <b-form-group label="Objectives stated in the description of this activity were met.">
                  <b-form-radio-group
                    id="btn-radios-1"
                    name="btn-radios-1"
                    v-model="$v.form.courseObjectives.$model"
                    :options="options"
                    buttons
                    :state="validateState('courseObjectives')"
                  ></b-form-radio-group>
                  <div class="validate-radio-error" v-if="validateRadio('courseObjectives')">{{requiredMsg}}</div>
                </b-form-group>

                <b-form-group label="Practically useful.">
                  <b-form-radio-group
                    id="btn-radios-2"
                    name="btn-radios-2"
                    v-model="$v.form.courseUseful.$model"
                    :options="options"
                    buttons
                    :state="validateState('courseUseful')"
                  ></b-form-radio-group>
                  <div class="validate-radio-error" v-if="validateRadio('courseUseful')">{{requiredMsg}}</div>
                </b-form-group>

                <b-form-group label="Appropriate, in-depth and comprehensive.">
                  <b-form-radio-group
                    id="btn-radios-3"
                    v-model="$v.form.courseAppropriate.$model"
                    :options="options"
                    buttons
                    name="btn-radios-3"
                    :state="validateState('courseAppropriate')"
                  ></b-form-radio-group>
                  <div class="validate-radio-error" v-if="validateRadio('courseAppropriate')">{{requiredMsg}}</div>
                </b-form-group>

                <b-form-group label="Logical and well organized.">
                  <b-form-radio-group
                    id="btn-radios-4"
                    v-model="$v.form.courseLogical.$model"
                    :options="options"
                    buttons
                    name="btn-radios-4"
                    :state="validateState('courseLogical')"
                  ></b-form-radio-group>
                  <div class="validate-radio-error" v-if="validateRadio('courseLogical')">{{requiredMsg}}</div>
                </b-form-group>

                <div class="div-eval-section">Please rate the presenter (if applicable).</div>

                <b-form-group label="Communication skills and clarity.">
                  <b-form-radio-group
                    id="btn-radios-5"
                    name="btn-radios-5"
                    v-model="$v.form.instructorCommunication.$model"
                    :options="options"
                    buttons
                    :state="validateState('instructorCommunication')"
                  ></b-form-radio-group>
                  <div class="validate-radio-error" v-if="validateRadio('instructorCommunication')">{{requiredMsg}}</div>
                </b-form-group>

                <b-form-group label="Preparedness.">
                  <b-form-radio-group
                    id="btn-radios-6"
                    v-model="$v.form.instructorPreparedness.$model"
                    :options="options"
                    buttons
                    name="btn-radios-6"
                    :state="validateState('instructorPreparedness')"
                  ></b-form-radio-group>
                  <div class="validate-radio-error" v-if="validateRadio('instructorPreparedness')">{{requiredMsg}}</div>
                </b-form-group>

                <b-form-group label="Effectiveness.">
                  <b-form-radio-group
                    id="btn-radios-7"
                    v-model="$v.form.instructorEffectiveness.$model"
                    :options="options"
                    buttons
                    name="btn-radios-7"
                    :state="validateState('instructorEffectiveness')"
                  ></b-form-radio-group>
                  <div class="validate-radio-error" v-if="validateRadio('instructorEffectiveness')">{{requiredMsg}}</div>
                </b-form-group>

                <div class="div-eval-section">Please rate your online experience.</div>

                <b-form-group label="Website speed.">
                  <b-form-radio-group
                    id="btn-radios-8"
                    v-model="$v.form.sitePresentation.$model"
                    :options="options"
                    buttons
                    name="btn-radios-8"
                    :state="validateState('sitePresentation')"
                  ></b-form-radio-group>
                  <div class="validate-radio-error" v-if="validateRadio('sitePresentation')">{{requiredMsg}}</div>
                </b-form-group>

                <b-form-group label="Ease of navigation through website.">
                  <b-form-radio-group
                    id="btn-radios-9"
                    v-model="$v.form.siteNavigation.$model"
                    :options="options"
                    buttons
                    name="btn-radios-9"
                    :state="validateState('siteNavigation')"
                  ></b-form-radio-group>
                  <div class="validate-radio-error" v-if="validateRadio('siteNavigation')">{{requiredMsg}}</div>
                </b-form-group>

                <b-form-group label="Overall rating of this site as compared to other CE online sites.">
                  <b-form-radio-group
                    id="btn-radios-10"
                    v-model="$v.form.siteComparison.$model"
                    :options="options"
                    buttons
                    name="btn-radios-10"
                    :state="validateState('siteComparison')"
                  ></b-form-radio-group>
                  <div class="validate-radio-error" v-if="validateRadio('siteComparison')">{{requiredMsg}}</div>
                </b-form-group>

                <b-form-group label="Please include any of your comments." label-for="comments" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                  <b-form-textarea
                      id="comments"
                      v-model="$v.form.comments.$model"
                      placeholder="Enter text here..."
                      rows="2"
                      max-rows="6"
                      :state="validateState('comments')"
                      aria-describedby="support-comments-feedback"
                  ></b-form-textarea>
                  <b-form-invalid-feedback v-if="!$v.form.comments.maxLength">Field exceeds maximum allowed length.</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="What other topics would you like included in future presentations?" label-for="comments" label-size="sm" class="mb-2" label-class="mb-0 pt-2 font-weight-bold">
                  <b-form-textarea
                      id="otherTopics"
                      v-model="$v.form.otherTopics.$model"
                      placeholder="Enter text here..."
                      rows="2"
                      max-rows="6"
                      :state="validateState('otherTopics')"
                      aria-describedby="support-otherTopics-feedback"
                  ></b-form-textarea>
                  <b-form-invalid-feedback v-if="!$v.form.otherTopics.maxLength">Field exceeds maximum allowed length.</b-form-invalid-feedback>
                </b-form-group>

                <transition name="fade" mode="out-in">
                  <div>
                    <b-alert v-model="error" key="error-box" show variant="danger" dismissible class="mt-2">
                      {{errorMsg}}
                    </b-alert>
                  </div>
                </transition>

                <b-button type="submit" variant="primary" class="mt-2 w-100">Submit Evaluation</b-button>
              </b-form>
            </div>
          </div>

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */
'use strict'

import service from "@/service/service";
import utils from "@/utils/utils";

import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: "EvalPodcast",
  data() {
    return {
      debug: false,
      loading: true,
      error: false,
      errorMsg: 'Technical error - contact support.',
      requiredMsg: 'Answer is required.',
      msg: "Evaluation",
      blurb:
        "In order to comply with AGD PACE requirements, an evaluation form needs to be completed. After completing and submitting this form you will be directed to the CE Exam. Thank you!",
      podcastHash: "",
      studentHash: this.$root.getToken(),
      podcast: {},
      studentData: { status: false },
      form: {
        courseObjectives: null,
        courseUseful: null,
        courseAppropriate: null,
        courseLogical: null,
        instructorCommunication: null,
        instructorPreparedness: null,
        instructorEffectiveness: null,
        sitePresentation: null,
        siteNavigation: null,
        siteComparison: null,
        comments: null,
        otherTopics: null
      },
      options: [
        { text: "Excellent", value: 4 },
        { text: "Good", value: 3 },
        { text: "Fair", value: 2 },
        { text: "Poor", value: 1 }
      ]
    }
  },
  props: {
    // route set to use props mapped to url parameters
    p: {
      type: String,
      required: true,
      default: ""
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      courseObjectives: {
        required
      },
      courseUseful: {
        required
      },
      courseAppropriate: {
        required
      },
      courseLogical: {
        required
      },
      instructorCommunication: {
        required
      },
      instructorPreparedness: {
        required
      },
      instructorEffectiveness: {
        required
      },
      sitePresentation: {
        required
      },
      siteNavigation: {
        required
      },
      siteComparison: {
        required
      },
      comments: {
        maxLength: maxLength(1024)
      },
      otherTopics: {
        maxLength: maxLength(1024)
      }
    }
  },
  methods: {
    validateState(name) {
      // console.log(`name: ${name}`)
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null;
    },
    validateRadio(name) {
      return this.$v.form[name].$dirty && !this.$v.form[name].required
    },
    submitEval(e) {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        console.log(`ERROR!!`)
        this.errorMsg = 'Correct errors and resubmit.'
        this.error = true
        return
      }

      let data = {}
      let evalData = {
        s: this.studentHash,
        c: null,
        p: this.podcastHash,
        a: this.form
      }
      service
        .saveEval(evalData)
        .then(data => {
          // console.log(`back from saveEval`);
          if (this.debug) console.log(data)
          if (data.status) {
            this.$router.push({ path: `/exam-podcast/${this.podcastHash}` })
          }
          else {
            this.error = true
            this.errorMsg = "Error saving evaluation.  Try again."
          }
        })
        .catch(e => console.log(e))
    }
  },
  created() {
    this.podcastHash = this.p || this.$route.query.p || ''
    if (this.podcastHash) {
      service
        .getPodcast(this.podcastHash, this.studentHash)
        .then( ( data => {
            // console.log(`back from getPodcast!`);
            if (this.debug) console.log(data);
            if (data.status && data.podcast.status) {
              this.podcast = data.podcast
              if (data.studentData.status) {
                this.studentData = data.studentData
                if (this.studentData.classViewCount === 0) {
                  alert('Please listen to podcast before taking exam.')
                  // this.$router.go(-1)  // previous page
                  this.$router.push({ path: `/podcast/${this.podcast.podcastShowHash}/${this.podcastHash}` })
                }
                else if (this.studentData.evalTaken) {
                  this.$router.push({ path: `/exam-podcast/${this.podcastHash}` })
                }
              }
              else {
                // Either bad student hash, or no gradebook record for this student.
                // Note - no way to detect if person watched on spotify.  Ignore this condition?
                alert('Please listen to podcast before taking exam.')
                this.$router.push({ path: `/podcast/${this.podcast.podcastShowHash}/${this.podcastHash}` })
              }
            }
            else {
              this.error = true
              this.errorMsg = "Error retrieving podcast data.  Refresh and try again."
            }
          }).bind(this)
        )
        .finally(e => {
          this.loading = false
          // console.log(`finally...`)
        })
        .catch(e => {
          this.error = true
          console.log('getPodcast', e)
        });
    } else {
      this.$router.push("podcasts");
    }
  },
  mounted () {
      this.form = {
        courseObjectives: null,
        courseUseful: null,
        courseAppropriate: null,
        courseLogical: null,
        instructorCommunication: null,
        instructorPreparedness: null,
        instructorEffectiveness: null,
        sitePresentation: null,
        siteNavigation: null,
        siteComparison: null,
        comments: null,
        otherTopics: null
      }
  },
  beforeDestroy() {
    this.loading = true
    this.error = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div-eval-section {
  color: black;
  border-top: solid 1px #888;
  border-bottom: solid 1px #888;
  font-weight: bold;
  background-color: #ccc;
  padding: 2px 5px;
  margin: 8px 0px;
}
.validate-radio-error {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// src/components/EvalPodcast.vue